import { createRng, RandomFn } from './seededRng.ts';

export type FirePosition = [row: number, col: number];

/** Deterministic starting fire layout using an existing RNG stream. */
export function getStartingFirePositionsFromRng(
  rng: RandomFn,
  gridSize: number,
  count: number
): FirePosition[] {
  const positions = new Set<string>();
  const result: FirePosition[] = [];
  const max = gridSize * gridSize;

  while (positions.size < Math.min(count, max)) {
    const row = Math.floor(rng() * gridSize);
    const col = Math.floor(rng() * gridSize);
    const key = `${row},${col}`;
    if (!positions.has(key)) {
      positions.add(key);
      result.push([row, col]);
    }
  }

  return result;
}

/** Deterministic starting fire layout from a seed (same algorithm as random init). */
export function getStartingFirePositions(
  seed: number,
  gridSize: number,
  count: number
): FirePosition[] {
  return getStartingFirePositionsFromRng(createRng(seed), gridSize, count);
}
